// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"2cc0dd20","511":"4e319b9d"}[chunkId] + ".chunk.js";
};